import { AfterViewInit, Component, ElementRef, inject, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { MatDialog } from '@angular/material/dialog';
import { SharedModule } from '../../shared/shared.module';

import { userApi } from '../../core/model/constants/endpoints';
import { CommonService } from '../../core/services/common.service';
import { JoinComponent } from '../../core/authentication/components/join/join.component';
import { ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs';
import { cultureSelctor } from '../../store/selectors/shared.selector';



@Component({
  selector: 'app-home',
  standalone: true,
  imports: [HeaderComponent, SharedModule],
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private commonService: CommonService,
    private activate: ActivatedRoute,
  ) { }

  private autoScrollInterval: any;
  private slider: any;
  isShowArrow: boolean = false;
  surveyCount: number = 0;
  respondentCount: number = 0;
  surveyPerDayCount1: number = 0;
  surveyPerDayCount2: number = 0;
  globalRewards: number = 0;
  liveSurveys: number = 0;
  respondents: number = 0;
  countryCount: number = 0;
  countries: number = 0;
  joinBonus: number = 0;

  zipCountryId: string;
  gender: any;
  countryLanguage: string;
  countryCode: string;
  userEarnQusn: any;
  signUpArray = [];
  questions: any;
  selectedOption: string | null = null;
  statusCodeMap = require('../../../app/core/model/constants/SCMapping.json')
  readonly dialog = inject(MatDialog);
  @ViewChild('videoPlayer', { static: false }) videoPlayer!: ElementRef;

  ngOnInit() {
    this.getCulture();
    this.commonService.userService.smoothCount(34, val => this.countries = val);
    this.getDailySurveyData();
    this.getAffiliateDetails();
    this.commonService.userService.redirectToDashboard();
  }



  ngOnDestroy() {
    clearInterval(this.autoScrollInterval);
  }

  AfterViewInit() {
    this.initializeVideo();
  }

  getAffiliateDetails() {
    this.commonService.storageService.removeSessionItem("_affiliateUrl")
    this.commonService.storageService.removeSessionItem("referralCode")
    // Method for affilate user
    this.activate.queryParams.subscribe(params => {
      const affilateid = params['affid'] || null;
      const transid = params['tid'] || null;
      const campid = params['campid'] || null;
      const scampid = params['scampid'] || null;
      if (affilateid || transid || campid || scampid) {
        this.commonService.storageService.setSessionItem("_affiliateUrl", window.location.search.substring(1));
        if (!localStorage.getItem('access_token')) {
          this.openDialog();
        }
      }
    });

    this.activate.params.subscribe(params => {

      const newReferralCode = params['id'];
      if (newReferralCode) {
        this.commonService.storageService.setSessionItem("referralCode", newReferralCode);
        return;
      }
      this.commonService.storageService.removeSessionItem("referralCode");
    });
  }

  openDialog() {
    this.commonService.storageService.setItem("qusn", JSON.stringify(this.questions))
    const dialogRef = this.dialog.open(JoinComponent, {
      panelClass: 'custom-dialog-container',
      id: 'joinCustomDialog',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.selectedOption = null;
    });
  }

  scrollLeft() {
    if (this.slider) {
      this.slider.scrollBy({
        top: 0,
        left: -this.slider.querySelector('.mat-card')!.clientWidth - 16, // card width + margin
        behavior: 'smooth'
      });
    }
  }

  handleUserMessage(event) {
    // Handle the user message event here
  }

  scrollRight() {
    if (this.slider) {
      this.slider.scrollBy({
        top: 0,
        left: this.slider.querySelector('.mat-card')!.clientWidth + 16, // card width + margin
        behavior: 'smooth'
      });
    }
  }

  private initializeVideo(): void {
    const video = this.videoPlayer?.nativeElement;
    if (video) {
      // Force play for Safari/iOS
      video.muted = true;
      video.defaultMuted = true;

      // Handle video load and play
      video.addEventListener('loadedmetadata', () => {
        video.play().catch(error => {
          this.handleAutoplayFailure();
        });
      });

      // Force load
      video.load();
    }
  }

  private handleAutoplayFailure(): void {
    const video = this.videoPlayer?.nativeElement;
    if (video) {
      // Add play button overlay for manual trigger
      const playButton = document.createElement('button');
      playButton.innerHTML = '▶️ Play Video';
      playButton.className = 'video-play-button';
      playButton.onclick = () => {
        video.play();
        playButton.remove();
      };

      video.parentElement?.appendChild(playButton);
    }
  }

  onHoverShowArrow() {
    this.isShowArrow = true;
  }

  onRemoveHover() {
    this.isShowArrow = false;
  }


  scrollToTop() {
    window.scrollTo(0, 0)
  }


  getDailySurveyData() {
    this.commonService.httpApiService.get(userApi.getDailySurveyData).then((res: any) => {
      this.commonService.userService.smoothCount(res.globalRewards, val => this.globalRewards = val);
      this.commonService.userService.smoothCount(res.respondents, val => this.respondents = val);
      this.commonService.userService.smoothCount(res.liveSurveys, val => this.liveSurveys = val);
      this.joinBonus = res?.joiningBonus / 100;
      localStorage.setItem('joinBonus', this.joinBonus.toString());
    }).catch((err) => {

    })
  }


 getCulture() {
    this.commonService.store.select(cultureSelctor).pipe(filter((res: any) => !!res?.culture)).subscribe((res: any) => {
      this.countryCode = res?.culture?.split('-')[1] || 'US';
    })
  }
}
